var _excluded = ["as", "space", "columns"],
    _excluded2 = ["children", "flex"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

import React, { Children } from "react";
import styled, { css } from "styled-components";
import { map } from "../breakpoint";
import { m, mt, p, pl } from "../spacing";
import { isList, isValidSpacing, getSpacingValue, spacingPropTypeMap, tilesColumnsPropTypeMap, mapColumnstoFlexBasis } from "../utils"; // eslint-disable-next-line @typescript-eslint/no-unused-vars

var TilesWrapper = styled(function (_ref) {
  var as = _ref.as,
      space = _ref.space,
      columns = _ref.columns,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("div", rest);
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: wrap;\n\n  // If set to be a <ul> or <ol> we need to reset the default list styling\n  ", "\n\n  // Negative left and top margins for parent\n  ", ";\n\n  // Positive left padding and top margin for child\n  > * {\n    box-sizing: border-box;\n    min-width: 0;\n    width: 100%;\n\n    ", ";\n  }\n\n  > * {\n    ", ";\n  }\n\n  // If grid is supported everything is a lot simpler\n  @supports (display: grid) {\n    display: grid;\n    ", ";\n\n    > * {\n      ", ";\n      ", ";\n    }\n\n    ", ";\n\n    ", ";\n  }\n"])), function (_ref2) {
  var as = _ref2.as;
  return as && isList(as) && css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      ", ";\n      ", ";\n      list-style-type: none;\n    "])), m(0), p(0));
}, function (_ref3) {
  var space = _ref3.space;
  return map(space, function (val) {
    return isValidSpacing(val) && css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n          margin-top: -", ";\n          margin-left: -", ";\n        "])), getSpacingValue(val), getSpacingValue(val));
  });
}, function (_ref4) {
  var space = _ref4.space;
  return map(space, function (val) {
    return isValidSpacing(val) && css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n            ", ";\n            // Have to use padding because of box model\n            ", ";\n          "])), mt(val), pl(val));
  });
}, function (_ref5) {
  var columns = _ref5.columns;
  return map(columns, function (val) {
    return val && mapColumnstoFlexBasis(val);
  });
}, m(0), m(0), p(0), function (_ref6) {
  var space = _ref6.space;
  return map(space, function (val) {
    return isValidSpacing(val) && css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n            grid-gap: ", ";\n          "])), getSpacingValue(val));
  });
}, function (_ref7) {
  var columns = _ref7.columns;
  return map(columns, function (val) {
    return val && css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n            grid-template-columns: repeat(", ", minmax(0, 1fr));\n          "])), val);
  });
});
var ChildWrapper = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  ", ";\n"])), function (_ref8) {
  var flex = _ref8.flex;
  return flex && "\n    display: flex;\n    width: 100%;\n  ";
});
ChildWrapper.displayName = "ChildWrapper";
export var Tiles = function Tiles(props) {
  var children = props.children,
      _props$flex = props.flex,
      flex = _props$flex === void 0 ? false : _props$flex,
      otherProps = _objectWithoutProperties(props, _excluded2);

  var childComponent = isList(props.as) ? "li" : "div";
  return /*#__PURE__*/React.createElement(TilesWrapper, otherProps, Children.map(children, function (child) {
    if ( /*#__PURE__*/React.isValidElement(child)) {
      return /*#__PURE__*/React.createElement(ChildWrapper, {
        as: childComponent,
        flex: flex
      }, child);
    }

    return null;
  }));
};
Tiles.displayName = "Tiles";
Tiles.defaultProps = {
  space: 0
};